module.exports = __webpack_public_path__ + "img/thumbnail_FennecFox_j_normal.b828e870.png";